<template>
    <v-container>
        <form-toolbar :canEdit="canEdit" :userRoles="userRoles" :editMode="editMode"  :field="'welding'" :assignment="assignment" @cancel-button-clicked="switchEditMode(false)" @edit-button-clicked="switchEditMode(true)"/>
        <v-form :readonly="readOnly" class="assignment-form">
            <v-card class = "form-group-fields" elevation="6">
                <div class="first-row">
                    <custom-datetime :value="localWelding.appointmentDate || ''" :readOnly="true" @onSelect="appointmentDateSelected"/>
                    <v-select
                        v-model="localWelding.status"
                        :items="statuses"
                        item-value="value"
                        item-text="name"
                        label="Κατάσταση"
                        outlined
                        class="field status"
                    ></v-select>
                    <v-dialog
                        v-if="this.assignment?.autopsy?.floorStructure"
                        v-model="dialog"
                        width="500"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="white--text"
                                large
                                :color="'black'"
                                :depressed="editMode">
                                Δομη Κτιριου
                            </v-btn>
                        </template>
                        <floor-structure :editMode="false" :stored="this.assignment.autopsy.floorStructure" />
                    </v-dialog>
                </div>
                <comments
                    ref="comments"
                    :comments="this.localWelding?.comments || {}"
                    :clearable="clearable"
                    :editMode="editMode"
                    :rules="editMode ? rules: []"
                    @new-comment="onNewComment"
                />
                <material-selection v-if="config.hasStorage" ref="material-selection" :editMode="editMode" :assignmentTab="'welding'" :assignment="assignment" />
                <image-section
                    v-if="!config.hasWeldingMultiplePhotoSections"
                    ref="image-section"
                    :editMode="editMode"
                    :readOnly="readOnly"
                    :clearable="clearable"
                    :uploadedPhotos="this.localWelding.photos || []"
                    :uploadPath="this.assignment.sr + '/welding'"
                    @photoSelection="onPhotoSelection"
                    :zipName="this.assignment.sr + '_' + 'welding'"
                />
                <div v-else class="multiple-images-wrapper">
                    <h3 class="text-center mb-2">Φωτογραφίες</h3>
                    <image-section
                        ref="image-section-bcp-bep"
                        :editMode="editMode"
                        :readOnly="readOnly"
                        :clearable="clearable"
                        :uploadedPhotos="this.localWelding.photos?.odefsiBcpBep || []"
                        :uploadPath="this.assignment.sr + '/welding/odefsi_bcp_bep'"
                        @photoSelection="onPhotoSelection"
                        :label="'Όδευση BCP BEP'"
                        :title="'Φωτογραφίες Όδευσης BCP BEP'"
                        :zipName="this.assignment.sr + '_' + 'welding_odefsi_bcp_bep'"
                    />
                    <image-section
                        ref="image-section-bcp"
                        :editMode="editMode"
                        :readOnly="readOnly"
                        :clearable="clearable"
                        :uploadedPhotos="this.localWelding.photos?.bcp || []"
                        :uploadPath="this.assignment.sr + '/welding/bcp'"
                        @photoSelection="onPhotoSelection"
                        :title="'Φωτογραφίες BCP'"
                        :label="'BCP'"
                        :zipName="this.assignment.sr + '_' + 'welding_bcp'"
                    />
                    <image-section
                        ref="image-section-bep-bmo"
                        :editMode="editMode"
                        :readOnly="readOnly"
                        :clearable="clearable"
                        :uploadedPhotos="this.localWelding.photos?.bepBmo || []"
                        :uploadPath="this.assignment.sr + '/welding/bep_bmo'"
                        @photoSelection="onPhotoSelection"
                        :title="'Φωτογραφίες BEP BMO'"
                        :label="'BEP BMO'"
                        :zipName="this.assignment.sr + '_' + 'welding_bep_bmo'"
                    />
                    <image-section
                        ref="image-section-fb"
                        :editMode="editMode"
                        :readOnly="readOnly"
                        :clearable="clearable"
                        :uploadedPhotos="this.localWelding.photos?.fb || []"
                        :uploadPath="this.assignment.sr + '/welding/fb'"
                        @photoSelection="onPhotoSelection"
                        :title="'Φωτογραφίες FB'"
                        :label="'FB'"
                        :zipName="this.assignment.sr + '_' + 'welding_fb'"
                    />
                    <image-section
                        ref="image-section-cabin"
                        :editMode="editMode"
                        :readOnly="readOnly"
                        :clearable="clearable"
                        :uploadedPhotos="this.localWelding.photos?.cabin || []"
                        :uploadPath="this.assignment.sr + '/welding/cabin'"
                        @photoSelection="onPhotoSelection"
                        :title="'Φωτογραφίες Καμπίνας'"
                        :label="'Καμπίνα'"
                        :zipName="this.assignment.sr + '_' + 'welding_cabin'"
                    />
                    <v-btn class="white--text" color="black" medium @click="downloadWeldingPhotosZip">ΚΑΤΕΒΑΣΜΑ ΟΛΩΝ <v-icon>mdi-download</v-icon></v-btn>
                </div>
                <file-section class="file-section" ref="file-section" :label="'Ανέβασμα Αρχείων'" :title="'Αρχεία'" :alreadyUploadedFiles="this.localWelding.measurementFiles || []" :editMode="editMode" :readOnly="readOnly" :clearable="clearable" :folderPath="this.assignment.sr + '/welding'" :zipName="this.assignment.sr + '_' + 'files' + '_' + 'welding'"/>
                <malfunction-extra-selections v-if="this.config.hasMalfunctionExtraSelections && assignment.type === 'MALFUNCTION'" :readOnly="readOnly" :alreadySelected="assignment?.extraInfo?.malfunction || {}" @on-selection="onMalfunctionSelection"/>
                <v-divider class="mt-5"/>
                <!-- <file-section ref="file-section" :label="'Ανέβασμα αρχείων OTDR'" :alreadyUploadedFiles="this.localWelding.measurementFiles || []" :editMode="editMode" :readOnly="readOnly" :clearable="clearable" :folderPath="this.assignment.sr + '/measurement'"/> -->
                <issue-existance-field
                    ref="prodesmeusi-difference-section"
                    :label="'Διαφορά από Προδέσμευση'"
                    :check="hasProdesmeusiDifference"
                    :comments="localWelding.prodesmeusiDifference?.comments || {}"
                    :readOnly="readOnly"
                    :clearable="clearable"
                    :editMode="editMode"
                    noImages
                />
                <v-divider />
                <issue-existance-field
                    ref="malfunction-section"
                    :label="'Βλάβη / Πρόβλημα'"
                    :photoLabel="'Φωτογραφίες Βλάβης'"
                    :check="hasMalfunction"
                    :comments="localWelding.malfunction?.comments || {}"
                    :uploadedPhotos="localWelding.malfunction?.photos || []"
                    :readOnly="readOnly"
                    :clearable="clearable"
                    :editMode="editMode"
                    :uploadPath="this.assignment.sr + '/welding/malfunction'"
                    @onIssuePhotoSelection="onTroublePhotoSelection"
                />
            </v-card>
            <div v-if="canEdit" class="submit-button-wrapper">
                <v-btn class="mx-2 white--text" :disabled="shouldDisableSubmit" :loading="loading" large color="black" @click="onSubmit">
                    ΥΠΟΒΟΛΗ
                </v-btn>
            </div>
            <waiting-message v-if="waitingMessage" :waiting-message="waitingMessage" />
        </v-form>
        <alert :show-alert="showAlert" :message="message" :type="type" />
    </v-container>
</template>

<script>
    import assignmentService from '@/services/assignment'
    import Alert from '@/components/Alert'
    import ImageSection from '@/components/ImageSection'
    import FormToolbar from '@/components/FormToolbar'
    import geolocation from '@/utils/geolocation'
    import MaterialSelection from '@/components/MaterialSelection'
    import FloorStructure from '@/components/FloorStructure'
    import Comments from '@/components/Comments'
    import momentTimezone from 'moment-timezone'
    import CustomDatetime from '@/components/CustomDatetime'
    import IssueExistanceField from '@/components/IssueExistanceField'
    import JSZip from 'jszip'
    import axios from 'axios'
    import { saveAs } from 'file-saver'
    import MalfunctionExtraSelections from '@/components/MalfunctionExtraSelections'
    import FileSection from '@/components/FileSection'
    import WaitingMessage from '@/components/WaitingMessage'
    const HETZNER_API_STORAGE_URL = process.env.VUE_APP_HETZNER_API_STORAGE_URL

    export default {
        name: 'WendingTab',
        components: { Alert, IssueExistanceField, MalfunctionExtraSelections, Comments, ImageSection, CustomDatetime, FormToolbar, MaterialSelection, FloorStructure, FileSection, WaitingMessage },
        watch: {
            assignment: {
                handler(newVal, oldVal) {
                    this.resetForm()
                },
                deep: true
            }
        },
        props: {
            assignment: {
                type: Object,
                required: true
            },
            currentUser: {
                type: Object,
                default: () => { return {} },
                required: true
            },
            canEdit: {
                type: Boolean,
                required: true
            }
        },
        computed: {
            userRoles() {
                return this.currentUser?.roles?.map(role => role.role) || []
            },
            shouldDisableSubmit() {
                if (this.localWelding.status === 'FOR_CANCELLING') {
                    return false
                }
                return !((this.localWelding.comments || this.newComment) && this.localWelding.appointmentDate && this.editMode)
            },
            config() {
                return this.$store.getters.getConfig || {}
            },
            statuses() {
                return this.config?.welding?.statuses || []
            }
        },
        data: () => {
            return {
                localWelding: {
                    description: null,
                    photos: []
                },
                selectedTroublePhotos: 0,
                newComment: null,
                hasMalfunction: false,
                hasProdesmeusiDifference: false,
                selectedPhotos: 0,
                showAlert: false,
                dialog: false,
                message: null,
                type: null,
                loading: false,
                mode: null,
                readOnly: false,
                clearable: true,
                rules: [
                    v => !!v || 'Το πεδίο είναι υποχρεωτικό'
                ],
                editMode: false,
                waitingMessage: null
            }
        },
        created() {
            this.mode = this.$route.params.mode
            if (this.mode === 'edit') {
                this.readOnly = true
                this.clearable = false
            }
            this.assignmentId = this.$route.params.assignmentId
        },
        mounted() {
            this.resetForm()
        },
        methods: {
            onMalfunctionSelection(selections) {
                this.localWelding.malfunctionExtraSelections = selections
            },
            isUrl(str) {
                try {
                    const url = new URL(str)
                    return url.protocol === 'http:' || url.protocol === 'https:'
                } catch {
                    return false
                }
            },
            async downloadWeldingPhotosZip() {
                const zip = new JSZip()
                const folder = zip.folder(this.assignment.sr + '_welding')
                let uploadedPhotos = []
                Object.values(this.localWelding.photos).forEach(photos => { uploadedPhotos = uploadedPhotos.concat(photos) })
                const downloadPromises = uploadedPhotos.map(async(url) => {
                    let photoUrl
                    if (this.isUrl(url)) {
                        photoUrl = url
                    } else {
                        photoUrl = HETZNER_API_STORAGE_URL + '/' + url
                    }
                    return axios
                        .get(photoUrl, {
                            headers: {
                                'Cache-Control': 'no-cache',
                                'Pragma': 'no-cache'
                            },
                            responseType: 'blob'
                        })
                        .then(response => {
                            // let fileName = url.substring(url.lastIndexOf('/')).substring(1)
                            folder.file(url.replace(this.assignment.sr + '/welding/', ''), response.data)
                        })
                        .catch(error => {
                            console.error(`Error fetching ${url}:`, error)
                        })
                })

                try {
                    await Promise.all(downloadPromises)
                    const content = await zip.generateAsync({ type: 'blob' })
                    saveAs(content, this.assignment.sr + '_welding.zip')
                } catch (error) {
                    console.error('Error generating ZIP:', error)
                }
            },
            appointmentDateSelected(datetime) {
                this.$set(this.localWelding, 'appointmentDate', momentTimezone(datetime).tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString())
            },
            onNewComment(e) {
                this.newComment = e
            },
            onTroublePhotoSelection(noOfSelectedPhotos) {
                this.selectedTroublePhotos = noOfSelectedPhotos
            },
            // downloadPrecommitmentFile() {
            //     if (!this.localWelding.precommitmentFileUrl) {
            //         return
            //     }
            //     file.downloadFile(process.env.VUE_APP_HETZNER_API_STORAGE_URL + '/' + this.localWelding.precommitmentFileUrl)
            // },
            tabSelect(tab) {
                this.selectedTab = tab
            },
            switchEditMode(editMode) {
                if (!this.canEdit) {
                    return
                }
                this.resetForm()
                if (editMode) {
                    this.readOnly = false
                    this.clearable = true
                    this.editMode = true
                } else {
                    this.readOnly = true
                    this.clearable = false
                    this.editMode = false
                }
            },
            onPhotoSelection(selectedPhotos) {
                this.selectedPhotos = selectedPhotos.length
            },
            resetForm() {
                this.localWelding = this.assignment.welding ? JSON.parse(JSON.stringify(this.assignment.welding)) : {}
                this.hasMalfunction = !!this.localWelding.malfunction
                this.hasProdesmeusiDifference = !!this.localWelding.prodesmeusiDifference
                if (this.localWelding.photos && typeof this.localWelding.photos === 'object' && !this.config.hasWeldingMultiplePhotoSections) {
                    let photoArray = []
                    for (const key of Object.keys(this.localWelding.photos)) {
                        photoArray = photoArray.concat(this.localWelding.photos[key])
                    }
                    this.localWelding.photos = photoArray
                }
            },
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 7000)
            },
            async uploadPhotos() {
                if (this.config.hasWeldingMultiplePhotoSections) {
                    if (!this.localWelding.photos || Array.isArray(this.localWelding.photos)) {
                        this.localWelding.photos = {}
                    }
                    this.localWelding.photos.odefsiBcpBep = this.localWelding.photos.odefsiBcpBep || []
                    this.localWelding.photos.bcp = this.localWelding.photos.bcp || []
                    this.localWelding.photos.bepBmo = this.localWelding.photos.bepBmo || []
                    this.localWelding.photos.fb = this.localWelding.photos.fb || []
                    this.localWelding.photos.cabin = this.localWelding.photos.cabin || []

                    if (this.isAdminOrCompanyCoordinator) {
                        try {
                            if (this.hasMalfunction) {
                                const deletedTroubleshootingPhotos = await this.$refs['malfunction-section'].deleteUploadedPhotos()
                                this.localWelding.malfunction.photos = deletedTroubleshootingPhotos ? this.localWelding.malfunction.photos.filter(photo => !deletedTroubleshootingPhotos.includes(photo)) : [ ...this.localWelding.malfunction.photos ]
                            }
                            const deletedPhotosOdefsiBcpBep = await this.$refs['image-section-bcp-bep'].deleteUploadedPhotos()
                            this.localWelding.photos.odefsiBcpBep = deletedPhotosOdefsiBcpBep ? this.localWelding.photos.odefsiBcpBep.filter(photo => !deletedPhotosOdefsiBcpBep.includes(photo)) : [ ...this.localWelding.photos.odefsiBcpBep ]
                            const deletedPhotosBcp = await this.$refs['image-section-bcp'].deleteUploadedPhotos()
                            this.localWelding.photos.bcp = deletedPhotosBcp ? this.localWelding.photos.bcp.filter(photo => !deletedPhotosBcp.includes(photo)) : [ ...this.localWelding.photos.bcp ]
                            const deletedPhotosBepBmo = await this.$refs['image-section-bep-bmo'].deleteUploadedPhotos()
                            this.localWelding.photos.bepBmo = deletedPhotosBepBmo ? this.localWelding.photos.bepBmo.filter(photo => !deletedPhotosBepBmo.includes(photo)) : [ ...this.localWelding.photos.bepBmo ]
                            const deletedPhotosFb = await this.$refs['image-section-fb'].deleteUploadedPhotos()
                            this.localWelding.photos.fb = deletedPhotosFb ? this.localWelding.photos.fb.filter(photo => !deletedPhotosFb.includes(photo)) : [ ...this.localWelding.photos.fb ]
                            const deletedPhotosCabin = await this.$refs['image-section-cabin'].deleteUploadedPhotos()
                            this.localWelding.photos.cabin = deletedPhotosCabin ? this.localWelding.photos.cabin.filter(photo => !deletedPhotosCabin.includes(photo)) : [ ...this.localWelding.photos.cabin ]
                        } catch (error) {
                            this.setAlert(error.message, 'error')
                            this.waitingMessage = null
                            this.loading = false
                            return
                        }
                    }
                    try {
                        if (this.hasMalfunction) {
                            const uploadedTroubleshootingPhotos = await this.$refs['malfunction-section'].uploadPhotos()
                            this.localWelding.malfunction.photos = uploadedTroubleshootingPhotos ? this.localWelding.malfunction.photos.concat(uploadedTroubleshootingPhotos) : [ ...this.localWelding.malfunction.photos ]
                        }
                        const uploadedPhotosBcpBep = await this.$refs['image-section-bcp-bep'].uploadPhotos()
                        if (!this.localWelding.photos.odefsiBcpBep) {
                            this.localWelding.photos.odefsiBcpBep = []
                        }
                        this.localWelding.photos.odefsiBcpBep = uploadedPhotosBcpBep ? this.localWelding.photos.odefsiBcpBep.concat(uploadedPhotosBcpBep) : [ ...this.localWelding.photos.odefsiBcpBep ]
                        const uploadedPhotosBcp = await this.$refs['image-section-bcp'].uploadPhotos()
                        if (!this.localWelding.photos.bcp) {
                            this.localWelding.photos.bcp = []
                        }
                        this.localWelding.photos.bcp = uploadedPhotosBcp ? this.localWelding.photos.bcp.concat(uploadedPhotosBcp) : [ ...this.localWelding.photos.bcp ]
                        const uploadedPhotosBepBmo = await this.$refs['image-section-bep-bmo'].uploadPhotos()
                        if (!this.localWelding.photos.bepBmo) {
                            this.localWelding.photos.bepBmo = []
                        }
                        this.localWelding.photos.bepBmo = uploadedPhotosBepBmo ? this.localWelding.photos.bepBmo.concat(uploadedPhotosBepBmo) : [ ...this.localWelding.photos.bepBmo ]
                        const uploadedPhotosFb = await this.$refs['image-section-fb'].uploadPhotos()
                        if (!this.localWelding.photos.fb) {
                            this.localWelding.photos.fb = []
                        }
                        this.localWelding.photos.fb = uploadedPhotosFb ? this.localWelding.photos.fb.concat(uploadedPhotosFb) : [ ...this.localWelding.photos.fb ]
                        const uploadedPhotosCabin = await this.$refs['image-section-cabin'].uploadPhotos()
                        if (!this.localWelding.photos.cabin) {
                            this.localWelding.photos.cabin = []
                        }
                        this.localWelding.photos.cabin = uploadedPhotosCabin ? this.localWelding.photos.cabin.concat(uploadedPhotosCabin) : [ ...this.localWelding.photos.cabin ]
                    } catch (error) {
                        this.setAlert(error.message, 'error')
                        this.waitingMessage = null
                        this.loading = false
                        return
                    }
                    return
                }
                if (!this.localWelding.photos) {
                    this.localWelding.photos = []
                }
                if (this.isAdminOrCompanyCoordinator) {
                    try {
                        const deletedPhotos = await this.$refs['image-section'].deleteUploadedPhotos()
                        this.localWelding.photos = deletedPhotos ? this.localWelding.photos.filter(photo => !deletedPhotos.includes(photo)) : [ ...this.localWelding.photos ]
                        if (this.hasMalfunction) {
                            const deletedTroubleshootingPhotos = await this.$refs['malfunction-section'].deleteUploadedPhotos()
                            this.localWelding.malfunction.photos = deletedTroubleshootingPhotos ? this.localWelding.malfunction.photos.filter(photo => !deletedTroubleshootingPhotos.includes(photo)) : [ ...this.localWelding.malfunction.photos ]
                        }
                    } catch (error) {
                        this.setAlert(error.message, 'error')
                        this.waitingMessage = null
                        this.loading = false
                        return
                    }
                }
                try {
                    const uploadedPhotos = await this.$refs['image-section'].uploadPhotos()
                    this.localWelding.photos = uploadedPhotos ? this.localWelding.photos.concat(uploadedPhotos) : [ ...this.localWelding.photos ]
                    if (this.hasMalfunction) {
                        const uploadedTroubleshootingPhotos = await this.$refs['malfunction-section'].uploadPhotos()
                        this.localWelding.malfunction.photos = uploadedTroubleshootingPhotos ? this.localWelding.malfunction.photos.concat(uploadedTroubleshootingPhotos) : [ ...this.localWelding.malfunction.photos ]
                    }
                } catch (error) {
                    this.setAlert(error.message, 'error')
                    this.waitingMessage = null
                    this.loading = false
                }
            },
            async editAssignment() {
                this.loading = true
                const coords = await geolocation.getCoordinates()

                if (!this.localWelding.measurementFiles) {
                    this.localWelding.measurementFiles = []
                }

                const malfunctionSection = this.$refs['malfunction-section'].getIssueValues()
                this.hasMalfunction = malfunctionSection.checked
                if (this.hasMalfunction) {
                    this.localWelding.malfunction = this.localWelding.malfunction || { photos: [] }
                    this.localWelding.malfunction.newComment = malfunctionSection.newComment
                }
                this.waitingMessage = 'Ανέβασμα Αρχείων...'
                await this.uploadPhotos()
                const uploadedFiles = await this.$refs['file-section'].uploadSelectedFiles()
                this.localWelding.measurementFiles = uploadedFiles ? this.localWelding.measurementFiles.concat(uploadedFiles) : [ ...this.localWelding.measurementFiles ]
                const prodesmeusiDifferenceSection = this.$refs['prodesmeusi-difference-section'].getIssueValues()
                this.hasProdesmeusiDifference = prodesmeusiDifferenceSection.checked
                if (this.hasProdesmeusiDifference) {
                    this.localWelding.prodesmeusiDifference = this.localWelding.prodesmeusiDifference || {}
                    this.localWelding.prodesmeusiDifference.newComment = prodesmeusiDifferenceSection.newComment
                }

                this.localWelding.geolocation = coords
                this.localWelding.newComment = this.newComment
                if (this.config.hasStorage) {
                    this.localWelding.materialsRequested = this.$refs['material-selection'].proccessMaterialRequested()
                }
                assignmentService.updateAssignmentTab('welding', this.assignment.id, { welding: this.localWelding }).then((response) => {
                    this.$refs['comments'].clear()
                    this.$refs['malfunction-section'].clear()
                    this.$refs['prodesmeusi-difference-section'].clear()
                    this.switchEditMode(false)
                    this.setAlert('Η ενημέρωση της κόλλησης ήταν επιτυχημένη', 'success')
                    this.$emit('assignment-refresh')
                }).catch((error) => {
                    this.setAlert(error?.response?.data?.message || 'Προέκυψε κάποιο σφάλμα. Παρακαλώ επικοινωνήστε με τον Διαχειριστή', 'error')
                }).finally(() => {
                    this.waitingMessage = null
                    this.loading = false
                })
            },
            async onSubmit() {
                if (this.mode === 'edit') {
                    this.editAssignment()
                }
            }
        }

    }
</script>
<style scoped>
.file-section {
    margin-bottom: 0.5rem;
}
.multiple-images-wrapper {
    border: solid 1px var(--cards-and-tables-text-color);
    padding: 1rem;
    border-radius: 5px;
    margin-bottom: 0.5rem;
    width: 100%;
    text-align-last: center;
}
.appointment-datetime {
    min-width: 200px;
    max-width: 20%;
}
.first-row {
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
    align-items: first baseline;
    margin-top: 0.8rem;
}
.form-group-fields {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
}

.body-label {
    color: rgba(0, 0, 0, 0.6);
}
.body-editor {
    margin-bottom: 2vh;
}
.edit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.submit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 2vh;
}

.edit-button-wrapper {
    display: flex;
    justify-content: flex-start;
}

.field.status {
    min-width: 270px;
    max-width: 20%;
}

.field.completed-checkbox {
    font-weight: 800;
}
.v-card {
    padding: 0.8rem;
    color: var(--cards-and-tables-text-color) !important;
    background: var(--cards-and-tables-color) !important;
}

</style>
